import Seo from "../Seo/Seo";
import BgSlider from "../Hero/bg";
import FaQ from "../FaQ/faq";

export default function Faq() {
    return <>
        <Seo
            title="FAQ | Provence Paie - Questions fréquentes sur la gestion paie et RH"
            description="Trouvez des réponses aux questions fréquentes sur les services paie, externalisation sociale et accompagnement RH proposés par Provence Paie."
            pathname="/FaQ"
        />
        <BgSlider
            title="PROVENCE PAIE"
            subtitle="Questions Fréquentes (FAQ)"
        />
        <FaQ />
    </>
}